import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=58166543&"
import script from "./Class.vue?vue&type=script&lang=ts&"
export * from "./Class.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports